<mat-dialog-content class="p-20 max-height-100 pos-relative">
  <div class="d-flex ai-center">
    <i-tabler name="arrow-left" class="icon-30 stroke-1 text-blackTitle" (click)="onClose()" />
  </div>
  <div class="over-auto">
    @if(orderCheck.OperatorLogin) {
    <div class="d-flex flex-column gap-10 ai-center m-b-30">
      <div class="rounded-circle bg-primary w-px-60 h-px-60 d-flex ai-center jc-center">
        <i-tabler name="user" class="icon-30 stroke-1 text-text-color" />
      </div>
      <div class="d-flex flex-column gap-5">
        <div class="f-s-16 f-w-600 text-blackTitle">
          {{orderCheck.OperatorLogin}}
        </div>
        <div class="f-s-14 text-danger d-flex ai-center gap-5" (click)="onLogout()">
          <i-tabler name="logout" class="icon-20 stroke-1" />
          Sair
        </div>
      </div>
    </div>
    }
    <div class="d-flex gap-10 ai-center b-b-1 p-y-10 text-text-primary" (click)="onChangeOrderCheck()">
      <i-tabler name="arrow-autofit-left" class="icon-30 stroke-1" />
      Alterar comanda/mesa
    </div>
    @if (!orderCheck.IsGroupCheck) {
    <div class="d-flex gap-10 ai-center b-b-1 p-y-10 text-text-primary" (click)="openCustomerNameBottomSheet()">
      <i-tabler name="user" class="icon-30 stroke-1" />
      Informar nome do cliente
    </div>
    }
    <div class="d-flex gap-10 ai-center b-b-1 p-y-10 text-text-primary"
      (click)="openOrderCheckObservationBottomSheet()">
      <i-tabler name="pencil" class="icon-30 stroke-1" />
      Observação da {{orderCheck.IsGroupCheck ? 'Mesa' : 'Comanda'}}
    </div>
    @if (!orderCheck.IsGroupCheck) {
    <div class="d-flex gap-10 ai-center b-b-1 p-y-10 text-text-primary" (click)="openBindTableBottomSheet()">
      <i-tabler name="link" class="icon-30 stroke-1" />
      Vincular uma mesa
    </div>
    }
    <app-theme-mode />
    <mat-divider class="m-y-20" />
    <app-products-view-mode />
    <mat-divider class="m-y-20" />
    <app-font-size />
  </div>
</mat-dialog-content>